import { paths } from '@AppRoutes/constants';
import store from '@Store';
import { resetConditionsNavigatorView } from './actions';

export function resetConditionsNavigator() {
  store.dispatch(resetConditionsNavigatorView());
}

function getWarnings(project) {
  return Array.isArray(project?.warnings) ? project.warnings.filter(Boolean) : [];
}

export function goToCreatedConditionsProject(history, project, { preferProjectsPage = false } = {}) {
  resetConditionsNavigator();
  const warnings = getWarnings(project);

  if (warnings.length > 0) {
    history.push({ pathname: paths.CONDITIONS, state: { conditionWarningMessages: warnings } });
    return;
  }

  if (!project?.resultCount && !project?.uniqueReactions) {
    history.push({ pathname: paths.CONDITIONS, state: { noConditionsFound: true } });
    return;
  }

  if (preferProjectsPage) {
    history.push(paths.CONDITIONS);
    return;
  }

  history.push(project?.id ? `${paths.CONDITIONS}/${project.id}` : paths.CONDITIONS);
}
